import { FC } from 'react';
import { useAccessibilityContext } from 'shared/contexts/accessibility-context';
import type { A11yTheme } from 'shared/hooks/use-accessibility';

const THEMES: { key: A11yTheme; label: string; className: string }[] = [
    { key: 'white', label: 'Чёрным по белому', className: 'a11y-sw-white' },
    { key: 'black', label: 'Белым по чёрному', className: 'a11y-sw-black' },
    { key: 'blue', label: 'Тёмно-синим по голубому', className: 'a11y-sw-blue' },
];

export const AccessibilityPanel: FC = () => {
    const {
        enabled,
        theme,
        images,
        letterSpacing,
        setTheme,
        setImages,
        setLetterSpacing,
        incFont,
        decFont,
        disable,
    } = useAccessibilityContext();

    if (!enabled) return null;

    return (
        <div className="a11y-panel" role="region" aria-label="Настройки версии для слабовидящих">
            <div className="a11y-group">
                <span className="a11y-label">Размер шрифта</span>
                <button type="button" onClick={decFont} aria-label="Уменьшить шрифт">А-</button>
                <button type="button" onClick={incFont} aria-label="Увеличить шрифт">А+</button>
            </div>

            <div className="a11y-group">
                <span className="a11y-label">Цвет сайта</span>
                {THEMES.map((item) => (
                    <button
                        key={item.key}
                        type="button"
                        className={`a11y-swatch ${item.className} ${theme === item.key ? 'is-active' : ''}`}
                        onClick={() => setTheme(item.key)}
                        aria-pressed={theme === item.key}
                        aria-label={item.label}
                    >
                        Ц
                    </button>
                ))}
            </div>

            <div className="a11y-group">
                <span className="a11y-label">Изображения</span>
                <button
                    type="button"
                    className={images === 'on' ? 'is-active' : ''}
                    onClick={() => setImages('on')}
                    aria-pressed={images === 'on'}
                >
                    Вкл
                </button>
                <button
                    type="button"
                    className={images === 'off' ? 'is-active' : ''}
                    onClick={() => setImages('off')}
                    aria-pressed={images === 'off'}
                >
                    Выкл
                </button>
            </div>

            <div className="a11y-group">
                <span className="a11y-label">Интервал</span>
                <button
                    type="button"
                    className={letterSpacing === 'normal' ? 'is-active' : ''}
                    onClick={() => setLetterSpacing('normal')}
                    aria-pressed={letterSpacing === 'normal'}
                >
                    Обычный
                </button>
                <button
                    type="button"
                    className={letterSpacing === 'large' ? 'is-active' : ''}
                    onClick={() => setLetterSpacing('large')}
                    aria-pressed={letterSpacing === 'large'}
                >
                    Большой
                </button>
            </div>

            <button type="button" className="a11y-normal" onClick={disable}>
                Обычная версия сайта
            </button>
        </div>
    );
};
